import SvgIcon from '@/components/SvgIcon';

const svg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.34998"
        y="3.5"
        width="1.5"
        height="9"
        rx="0.75"
        transform="rotate(30 9.34998 3.5)"
        fill="#D5D6D9"
      />
    </svg>
  );
};
const SeparatorIcon = (props) => {
  return <SvgIcon component={svg} {...props} />;
};
export default SeparatorIcon;
